/* eslint-disable perfectionist/sort-imports */
import 'src/global.css';

// i18n
import 'src/locales/i18n';

// ----------------------------------------------------------------------

import Router from 'src/routes/sections';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
import { useDynamicFavicon } from 'src/hooks/use-dynamic-favicon';

import ThemeProvider from 'src/theme';
import { LocalizationProvider } from 'src/locales';

import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
import { SettingsProvider } from 'src/components/settings';

import { useEffect } from 'react';
import { useWhitelabelStore } from './store/whitelabel/whitelabel.store';
import { SplashScreen } from './components/loading-screen';
import { getSiteName } from './utils/host-name';
import { AuthProvider } from './auth';

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();
  useDynamicFavicon();

  const { loading, fetchWhitelabel } = useWhitelabelStore();

  useEffect(() => {
    fetchWhitelabel(getSiteName());
  }, []);

  return loading ? (
    <SplashScreen />
  ) : (
    <AuthProvider>
      <LocalizationProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light', // 'light' | 'dark'
            themeDirection: 'ltr', //  'rtl' | 'ltr'
            themeContrast: 'default', // 'default' | 'bold'
            themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <MotionLazy>
              <SnackbarProvider>
                <ProgressBar />
                <Router />
              </SnackbarProvider>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </AuthProvider>
  );
}
